import React from 'react';
import { FormicaProps, withFormica } from 'helpers/withFormica';
import { history } from '../Bootstrap';
import { RootState } from '../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { ComponentState } from '../redux/actions/ComponentActions';

class PageBlocker extends React.Component<Props> {
  private blocker: VoidFunction | undefined;

  private preventPrevious = 1;

  public render() {
    return null;
  }

  public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any) {
    if (this.props.router.location != prevProps.router.location && this.props.component.isDirty) {
      this.preventPrevious++;
      if (this.preventPrevious % 2 == 0) {
        this.handlePageChange();
      }
    }

    if (!this.props.component.isDirty) {
      this.blocker?.();
      this.blocker = undefined;
    } else {
      this.initializeBlocker();
    }
  }

  private handlePageChange = () => {
    if (!window.confirm('Emin misin')) {
      history.go(-1);
    }
  };

  private initializeBlocker = () => {
    if (this.blocker == undefined) {
      this.blocker = history.block(() => {
        return 'Emin misin?';
      });
    }
  };
}

interface Props extends FormicaProps, ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  component: state.component as ComponentState,
});

const mapDispatchToProps = {};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(withFormica(PageBlocker));
